export const ROOF_TYPES = [
  {
    label: 'Architectural Shingles',
    value: 'Architectural Shingles',
  },
  {
    label: 'Asbestos',
    value: 'Asbestos',
  },
  {
    label: 'Asphalt Shingles',
    value: 'Asphalt Shingles',
  },
  {
    label: 'Composition',
    value: 'Composition',
  },
  {
    label: 'Copper (Flat)',
    value: 'Copper (Flat)',
  },
  {
    label: 'Copper (Pitched)',
    value: 'Copper (Pitched)',
  },
  {
    label: 'Corrugated Steel (Flat)',
    value: 'Corrugated Steel (Flat)',
  },
  {
    label: 'Corrugated Steel (Pitched)',
    value: 'Corrugated Steel (Pitched)',
  },
  {
    label: 'Fiberglass',
    value: 'Fiberglass',
  },
  {
    label: 'Foam',
    value: 'Foam',
  },
  {
    label: 'Gravel',
    value: 'Gravel',
  },
  {
    label: 'Metal (Flat)',
    value: 'Metal (Flat)',
  },
  {
    label: 'Metal (Pitched)',
    value: 'Metal (Pitched)',
  },
  {
    label: 'Mineral Fiber Shake',
    value: 'Mineral Fiber Shake',
  },
  {
    label: 'Other',
    value: 'Other',
  },
  {
    label: 'Plastic (Flat)',
    value: 'Plastic (Flat)',
  },
  {
    label: 'Plastic (Pitched)',
    value: 'Plastic (Pitched)',
  },
  {
    label: 'Rock',
    value: 'Rock',
  },
  {
    label: 'Rolled Paper (Flat)',
    value: 'Rolled Paper (Flat)',
  },
  {
    label: 'Rolled Paper (Pitched)',
    value: 'Rolled Paper (Pitched)',
  },
  {
    label: 'Rubber Flat',
    value: 'Rubber Flat',
  },
  {
    label: 'Rubber (Pitched)',
    value: 'Rubber (Pitched)',
  },
  {
    label: 'Slate',
    value: 'Slate',
  },
  {
    label: 'Tar',
    value: 'Tar',
  },
  {
    label: 'Tar and Gravel',
    value: 'Tar and Gravel',
  },
  {
    label: 'Tile (Clay)',
    value: 'Tile (Clay)',
  },
  {
    label: 'Tile (Concrete)',
    value: 'Tile (Concrete)',
  },
  {
    label: 'Tile (Spanish)',
    value: 'Tile (Spanish)',
  },
  {
    label: 'Tin (Flat)',
    value: 'Tin (Flat)',
  },
  {
    label: 'Tin (Pitched)',
    value: 'Tin (Pitched)',
  },
  {
    label: 'Wood Fiberglass Shingles',
    value: 'Wood Fiberglass Shingles',
  },
  {
    label: 'Wood Shake',
    value: 'Wood Shake',
  },
  {
    label: 'Wood Shingles',
    value: 'Wood Shingles',
  },
];
